import { useState } from 'react';
import { LegalModal } from '../ui/LegalModal';
import type { YamlSlug } from '../../utils/yamlLoader';

const FOOTER_LINKS: readonly { label: string; slug: YamlSlug }[] = [
  { label: 'Kontakt', slug: 'kontakt' },
  { label: 'Rechtliches', slug: 'rechtliches' },
  { label: 'Datenschutz', slug: 'datenschutz' },
  { label: 'Impressum', slug: 'impressum' },
];

/** App-Footer mit Copyright-Zeile und Legal-Links, die Texte per Modal aus YAML-Dateien laden. */
export function Footer() {
  const [activeSlug, setActiveSlug] = useState<YamlSlug | null>(null);

  return (
    <footer className="site-footer no-print">
      <div className="page-container site-footer__inner">
        <p className="site-footer__copy">
          © {new Date().getFullYear()} Passt Instagram als Sichtbarkeitskanal?
        </p>
        <nav className="site-footer__links" aria-label="Rechtliche Informationen">
          {FOOTER_LINKS.map(({ label, slug }) => (
            <button
              key={slug}
              type="button"
              className="site-footer__link"
              onClick={() => setActiveSlug(slug)}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
      <LegalModal slug={activeSlug} onClose={() => setActiveSlug(null)} />
    </footer>
  );
}
